import { render, staticRenderFns } from "./forms-list.vue?vue&type=template&id=410d63de&scoped=true&"
import script from "./forms-list.vue?vue&type=script&lang=js&"
export * from "./forms-list.vue?vue&type=script&lang=js&"
import style0 from "./forms-list.vue?vue&type=style&index=0&id=410d63de&scoped=true&lang=scss&"
import style1 from "./forms-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d63de",
  null
  
)

component.options.__file = "forms-list.vue"
export default component.exports